import ApiBase from "./ApiBase";

class ProductStoreMatrixApi {
  fetchAll(params) {
    return ApiBase.get("/product_store_matrices", params);
  }

  toggle({ style_color, store_id, is_selected }) {
    return ApiBase.post("/product_store_matrices/toggle", {
      style_color,
      store_id,
      is_selected,
    });
  }

  bulkToggle(updates) {
    return ApiBase.post("/product_store_matrices/bulk_toggle", updates);
  }

  sendToAllocation(payload) {
    return ApiBase.post("/product_store_matrices/send_to_allocation", payload).then(
      (response) => response.data
    );
  }
}

export default new ProductStoreMatrixApi();
